(() => {
  const storageKey = 'm-wishlist-products';
  const labels = window.mevWishlistLabels || {};
  const readWishlist = () => {
    try {
      const data = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(data) ? data.filter(value => typeof value === 'string') : [];
    } catch { return []; }
  };
  const refreshButtons = () => {
    const handles = readWishlist();
    document.querySelectorAll('[data-mev-wishlist]').forEach(button => {
      const selected = handles.includes(button.dataset.mevWishlist);
      const label = selected ? labels.remove : labels.add;
      button.setAttribute('aria-pressed', String(selected));
      if (label) {
        button.setAttribute('aria-label', label);
        button.title = label;
        if (button.classList.contains('mev-wishlist-button')) button.textContent = label;
      }
    });
  };
  const renderWishlist = async () => {
    const list = document.querySelector('[data-mev-wishlist-list]');
    if (!list) return;
    const handles = readWishlist();
    const empty = document.querySelector('[data-mev-wishlist-empty]');
    if (empty) empty.hidden = handles.length > 0;
    list.replaceChildren();
    const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
    const cards = await Promise.all(handles.map(async handle => {
      try {
        const response = await fetch(`${root}/products/${encodeURIComponent(handle)}.js`);
        if (!response.ok) return null;
        const product = await response.json();
        const article = document.createElement('article');
        article.className = 'mev-wishlist-card';
        const link = document.createElement('a');
        link.href = `${root}/products/${encodeURIComponent(handle)}`;
        if (product.featured_image) {
          const img = document.createElement('img');
          img.src = product.featured_image;
          img.alt = product.title;
          img.loading = 'lazy';
          link.append(img);
        }
        const title = document.createElement('h2');
        title.textContent = product.title;
        link.append(title);
        const price = document.createElement('p');
        price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'da', { style: 'currency', currency: window.Shopify?.currency?.active || 'DKK' }).format(product.price / 100);
        link.append(price);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'button med-btn mev-wishlist-button';
        remove.dataset.mevWishlist = handle;
        remove.textContent = labels.remove || '';
        article.append(link, remove);
        return article;
      } catch { return null; }
    }));
    cards.filter(Boolean).forEach(card => list.append(card));
    if (empty) empty.hidden = list.childElementCount > 0;
    refreshButtons();
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-mev-wishlist]');
    if (button) {
      event.preventDefault();
      const handle = button.dataset.mevWishlist;
      const handles = readWishlist();
      const next = handles.includes(handle) ? handles.filter(value => value !== handle) : [...handles, handle];
      try { localStorage.setItem(storageKey, JSON.stringify(next)); } catch { return; }
      refreshButtons();
      renderWishlist();
    }
    const checkout = event.target.closest('[data-mev-terms-checkout]');
    if (checkout) {
      const checkbox = checkout.closest('.cart-btn-container').querySelector('[data-mev-terms]');
      if (checkbox && !checkbox.checked) { event.preventDefault(); checkbox.reportValidity(); }
    }
  });
  document.addEventListener('teeinblue-event-component-injected', () => {
    const color = document.querySelector('.tee-option--color');
    const size = document.querySelector('.tee-option--size');
    if (color && size) size.after(color);
  });
  document.addEventListener('shopify:section:load', refreshButtons);
  window.addEventListener('storage', () => { refreshButtons(); renderWishlist(); });
  const start = () => {
    refreshButtons();
    renderWishlist();
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-mev-wishlist]') || node.querySelector('[data-mev-wishlist]'))))) refreshButtons();
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
